import { NGXLogger } from 'ngx-logger';
import { ConfigService } from 'ngx-envconfig';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { EncryptionService } from '../../shared/services/encryption.service';


@Injectable({
  providedIn: 'root'
})
export class PaiementService {

  items: any[];

  head = new HttpHeaders({'Access-Control-Allow-Origin' : '*'});

  // const head1 = new HttpHeaders({'Content-Type':'application/json; charset=utf-8', });


  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
    private configService: ConfigService,
    private encryption:EncryptionService,
  ) {  }

  private clientUrlPresta = this.configService.get('ipPresta');
  private clientUrlWebgui = this.configService.get('ip');
  private clientUrlMtn = this.configService.get('ipMtn');
  private clientUrlMoov = this.configService.get('ipMoov');
  private waveUrl = this.configService.get('waveUrl');
  // private clientUrlOrange = this.configService.get('ipOrange');
  private clientUrlOrange = 'https://kyrmannpay.com:9223/kyrmannpay/orangeci/';



  public verificationService(afid: number): Observable<HttpResponse<any>> {
    return this.http.get(this.clientUrlWebgui + '' + afid, {
      observe: 'response',
      responseType: 'text'
    });
  }

  /**
   *
   * @param user Initialisé paiement via MTN
   * @param pass
   * @param num
   * @param amount
   * @param ref
   * @param afid
   */
  public paiementMTN(user: String, pass: String, num: String, amount: number, ref: String, afid: String,otp:String,operator:String,category:String,sessionid:string,offreid?:String,data?:String): Observable<HttpResponse<any>> {
    // this.logger.trace('SERVICE', this.clientUrlMtn + 'web/pay?user=' + user + '&pswd=' + pass + '&msisdn=' + num + '&amount=' + amount + '&ref=' + ref + '&afid=' + afid);
    let payobject = {
      "user": user,
      "pswd": pass,
      "msisdn" : num,
      "amount": amount,
      "ref" : ref,
      "afserviceid" : afid,
      "offreid": offreid,
      "otp" : otp,
      "operator" : operator,
      "category" : category,
      "sessionid" : sessionid,
      "data": data
    };
    let result = this.encryption.encryptUsingAES256(JSON.stringify(payobject));
    // this.clientUrlMtn
    return this.http.get( this.clientUrlMtn + 'web/payc?request=' + encodeURIComponent(result), {
      observe: 'response'
    });
  }

    /**
   *
   * @param user Initialisé paiement et obtenir statut via MOOV
   * @param pass
   * @param num
   * @param amount
   * @param ref
   * @param afid
   */
  // public paiementMOOV(user: string, pass: string, num: string, amount: number, ref: String, afid: String,otp:String,operator:String,category:String,sessionid:string,offreid?:String,data?:String): Observable<HttpResponse<any>> {
  //   return this.http.get(this.clientUrlMoov + 'web/pay?user=' + user + '&pswd=' + pass + '&msisdn=' + num + '&amount=' + amount + '&ref=' + ref + '&afserviceid=' + afid+ '&otp=' + otp+ '&operator=' + operator+ '&category=' + category+ '&sessionid=' + sessionid+ '&offreid=' + offreid+ '&data=' + data, {
  //     observe: 'response',
  //     responseType: 'json'
  //   });
  // }

  /**
   *
   * @param user Initialisé paiement et obtenir statut via MOOV
   * @param pass
   * @param num
   * @param amount
   * @param ref
   * @param afid
   */
  public paiementMOOV(user: String, pass: String, num: String, amount: String, ref: String, afid: String,otp:String,operator:String,category:String,sessionid:string,offreid?:String,data?:String): Observable<HttpResponse<any>> {
    let payobject = {
      "user": user,
      "pswd": pass,
      "msisdn" : num,
      "amount": amount,
      "ref" : ref,
      "afserviceid" : afid,
      "offreid": offreid,
      "otp" : otp,
      "operator" : operator,
      "category" : category,
      "sessionid" : sessionid,
      "data": data
    };
    let result = this.encryption.encryptUsingAES256(JSON.stringify(payobject));
    // this.clientUrlMoov
    return this.http.get(this.clientUrlMoov+'web/pay?request=' + encodeURIComponent(result), {
      observe: 'response',
      responseType: 'json'
    });
  }

  public paiementORANGE(user: String, pass: String, num: String, amount: String, ref: String, afid: String,otp:String,operator:String,category:String,sessionid:string,offreid?:String,data?:String): Observable<HttpResponse<any>> {
    let payobject = {
      "user": user,
      "pswd": pass,
      "msisdn" : num,
      "amount": amount,
      "ref" : ref,
      "afserviceid" : afid,
      "offreid": offreid,
      "otp" : otp,
      "operator" : operator,
      "category" : category,
      "sessionid" : sessionid,
      "data": data
    };
    let result = this.encryption.encryptUsingAES256(JSON.stringify(payobject));
    // let result = this.encryption.encryptUsingAES256('ompay/web/pay?user=' + user + '&pswd=' + pass + '&msisdn=' + num + '&amount=' + amount + '&ref=' + ref + '&afserviceid=' + afid + '&otp=' + otp + '&operator=' + operator  + '&category=' + category  + '&sessionid=' + sessionid + '&offreid=' + offreid);
    // this.clientUrlOrange + 'ompay/web/pay?request='
    return this.http.get('https://kyrmannpay.com:9223/kyrmannpay/orangeci/ompay/web/pay?request='+ encodeURIComponent(result), {
      observe: 'response',
      responseType: 'json',
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    });
  }

  public paiementWAVE(user: String, pass: String,num: String, amount: number, ref: String, afid: String,otp:String,operator:String,category:String,sessionid:string,offreid?:String,data?:String,urlcallback?:String): Observable<HttpResponse<any>> {
    
    let payobject = {
      "user": user,
      "pswd": pass,
      "msisdn" : num,
      "amount": amount,
      "ref" : ref,
      "afserviceid" : afid,
      "offreid": offreid,
      "otp" : otp,
      "operator" : operator,
      "category" : category,
      "sessionid" : sessionid,
      "data": data,
      "urlcallback":urlcallback
    };
    let result = this.encryption.encryptUsingAES256(JSON.stringify(payobject));
    console.log('==PAIEMENT WAVE==',this.waveUrl)
    return this.http.get(this.waveUrl+ encodeURIComponent(result), {
      observe: 'response',
      responseType: 'json',
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    });
  }



  /**
   * Verifier le statut de l'achat sur MTN
   * @param achatbillmaptransid
   * @param achatewptransid
   * @param afpaytransactionid
   */
  public  verifierPaiement(achatbillmaptransid: string, achatewptransid: string, afpaytransactionid: string): Observable<HttpResponse<any>> {
    let payobject = {
      "achatbillmaptransid" : achatbillmaptransid,
      "achatewptransid" : achatewptransid,
      "achattransactionid" : afpaytransactionid
    };
    let result = this.encryption.encryptUsingAES256(JSON.stringify(payobject));
    this.clientUrlMtn
    return this.http.get('https://kyrmannpay.com:9241/kyrmannpay/dataresource/achat/getachatdetail?request=' + encodeURIComponent(result), {
      observe: 'response',
      responseType: 'text'
    });
  }

  /**
   * Verifier le statut de l'achat sur MTN
   * @param achatbillmaptransid
   * @param achatewptransid
   * @param afpaytransactionid
   */
  public  verifierPaiementMoov(afpaytransactionid: string): Observable<HttpResponse<any>> {
    let payobject = {
      "achattransactionid" : afpaytransactionid
    };
    let result = this.encryption.encryptUsingAES256(JSON.stringify(payobject));
    this.clientUrlMtn
    return this.http.get('https://kyrmannpay.com:9241/kyrmannpay/dataresource/achat/getachatdetailMoov?request=' + encodeURIComponent(result), {
      observe: 'response',
      responseType: 'text'
    });
  }


  public  verifierPaiementOrange(tid: string,token:String, sessionid:String): Observable<HttpResponse<any>> {
    let payobject = {
      "achatbillmaptransid" : sessionid,
      "achatewptransid": token,
      "achattransactionid":tid
    };
    let result = this.encryption.encryptUsingAES256(JSON.stringify(payobject));
    // this.clientUrlOrange
    return this.http.get('https://kyrmannpay.com:9241/kyrmannpay/dataresource/achat/getachatdetail?request='+ encodeURIComponent(result), {
      observe: 'response',
      responseType: 'text'
    });
  }


  public getClientfournisseur(user: string, pass: string): Observable<HttpResponse<any>> {

    return this.http.get(this.clientUrlWebgui + 'clientfournisseur/verifyuser' , {
      observe: 'response',
      params: {login: user, password: pass}
    });
  }

  public curlUrlRetour(curl, idcart: String, idcustomer: number, token): Observable<HttpResponse<any>> {
    return this.http.get(curl + '&id_cart=' + idcart + '&id_customer=' + idcustomer + '&success=' + token , {
      observe: 'response',
      headers: new HttpHeaders({'Access-Control-Allow-Origin' : '*'}),
      responseType: 'text'
    });
  }

  public curlVAS(curl: string, idcustomer: number, totalpaid: string, opPaiement: string, msisdnPaiement: string): Observable<HttpResponse<any>> {
    return this.http.get(curl + '/' + idcustomer + '/' + totalpaid + '/' + opPaiement + '/' + msisdnPaiement , {
      observe: 'response',
      headers: new HttpHeaders({'Access-Control-Allow-Origin' : '*'})
    });
  }

  public curlMS(urlCrypter): Observable<HttpResponse<any>> {
    return this.http.get(this.clientUrlPresta + 'angular/' , {
      observe: 'response',
      headers: new HttpHeaders({'Access-Control-Allow-Origin' : '*'}),
      params: {curl: urlCrypter}
    });
  }


  public postresponse(url,data): Observable<HttpResponse<any>> {
    return this.http.post(url, data, {
      observe: 'response',
      // responseType: 'text',
    });
  }

}
